import React from "react";
import { Fragment } from "react";

import { Container } from "../../components";
import { lazyWithRetry } from "../../core/lazy_with_retry";
import { useI18n } from "../../lib/i18n/i18n_provider";
import { getLanguageComponent } from "../../lib/locale/locale";
import { TemplateOfferingListingMeetingRoom } from "../template_offering_listing_meeting_room";
import { Text } from "../text";
import { useWeWorkAnalytics } from "./wework_analytics";
import {
  faqsMeetingRoomEN,
  faqsMeetingRoomHE,
  useWeWorkPartnerConfig,
} from "./wework_partner_config";

const Theme = lazyWithRetry(() => import("./wework_theme"));

export function OfferingWeWorkListingMeetingRoom() {
  useWeWorkAnalytics();
  const { locale } = useI18n();
  const partnerConfig = useWeWorkPartnerConfig();
  return (
    <Fragment>
      <Theme />
      <TemplateOfferingListingMeetingRoom
        partnerConfig={partnerConfig}
        data={{
          faqs:
            locale.baseLanguageTag === "he"
              ? faqsMeetingRoomHE
              : faqsMeetingRoomEN,
          title: text[getLanguageComponent(locale.languageTag)].title,
          description: (
            <Container>
              <Text>
                {text[getLanguageComponent(locale.languageTag)].descriptionMain}
              </Text>
              <Text>
                {text[getLanguageComponent(locale.languageTag)].description}
              </Text>
            </Container>
          ),
        }}
      />
    </Fragment>
  );
}

const text: {
  [lang: string]: {
    title: string;
    descriptionMain: string;
    description: string;
  };
} = {
  en: {
    title: "Book a Conference Room at WeWork",
    descriptionMain: "Book a premium conference room at a WeWork location.",
    description:
      "Whether you need a meeting space for a team meeting, an off-site, or just looking for a private space for working productively - we’ve got you covered. Reserve a room in advance, check in, and get to work.",
  },
  he: {
    title: "שריינו חדר ישיבות ב-WeWork",
    descriptionMain: "שריינו את חדרי הישיבות בסטנדרט הבינלאומי של-WeWork.",
    description:
      "בין אם אתם צריכים חלל לפגישת צוות, לפעילות גיבוש או סתם חלל פרטי לעבודה פרודוקטיבית, אנחנו כאן בדיוק בשביל זה. אז איך זה עובד? מזמינים חדר ישיבות, מגיעים ביום ההזמנה לצ'ק אין זריז עם הצוות שלנו בדלפק הכניסה וניגשים לעניינים.",
  },
};
